// File Metadata:
// Filename: shipmentConstants.js
// Version: 1.00
// Created: 2025-03-25 23:07:04
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import {
    Pending as PendingIcon,
    PlayArrow as InProgressIcon,
    CheckCircle as CompletedIcon,
    PauseCircle as OnHoldIcon,
    PhotoCamera as ImageAddedIcon,
    DeleteOutline as ImageRemovedIcon,
    Edit as EditIcon,
    Assignment as AssignmentIcon,
    Comment as CommentIcon,
    LocalShipping as TourIcon,
    Inventory as TypeIcon,
    Notes as NotesIcon,
    QrCode as SSCCIcon
} from '@mui/icons-material'

// Actual shipment statuses that can be selected
export const SHIPMENT_STATUS = {
    PENDING: {
        value: 'PENDING',
        label: 'Pending',
        color: 'default',
        icon: PendingIcon
    },
    IN_PROGRESS: {
        value: 'IN_PROGRESS',
        label: 'In Progress',
        color: 'primary',
        icon: InProgressIcon
    },
    COMPLETED: {
        value: 'COMPLETED',
        label: 'Completed',
        color: 'success',
        icon: CompletedIcon
    },
    ON_HOLD: {
        value: 'ON_HOLD',
        label: 'On Hold',
        color: 'warning',
        icon: OnHoldIcon
    }
}

// Activity types for timeline display
export const ACTIVITY_TYPES = {
    IMAGE_ADDED: {
        value: 'IMAGE_ADDED',
        label: 'Image Added',
        color: 'info',
        icon: ImageAddedIcon
    },
    IMAGE_REMOVED: {
        value: 'IMAGE_REMOVED',
        label: 'Image Removed',
        color: 'warning',
        icon: ImageRemovedIcon
    },
    SSCC_UPDATED: {
        value: 'SSCC_UPDATED',
        label: 'SSCC Updated',
        color: 'info',
        icon: SSCCIcon
    },
    TYPE_UPDATED: {
        value: 'TYPE_UPDATED',
        label: 'Type Updated',
        color: 'info',
        icon: TypeIcon
    },
    TOUR_UPDATED: {
        value: 'TOUR_UPDATED',
        label: 'Tour Updated',
        color: 'info',
        icon: TourIcon
    },
    NOTES_UPDATED: {
        value: 'NOTES_UPDATED',
        label: 'Notes Updated',
        color: 'info',
        icon: NotesIcon
    },
    COMMENT_ADDED: {
        value: 'COMMENT_ADDED',
        label: 'New Comment',
        color: 'info',
        icon: CommentIcon
    },
    ASSIGNED: {
        value: 'ASSIGNED',
        label: 'Assigned',
        color: 'info',
        icon: AssignmentIcon
    },
    ASSIGNED_UPDATED: {
        value: 'ASSIGNED_UPDATED',
        label: 'Assigned',
        color: 'primary',
        icon: AssignmentIcon
    }
}

export const PRIORITY_LEVELS = {
    LOW: {
        value: 'LOW',
        label: 'Low',
        color: 'info'
    },
    MEDIUM: {
        value: 'MEDIUM',
        label: 'Medium',
        color: 'warning'
    },
    HIGH: {
        value: 'HIGH',
        label: 'High',
        color: 'error'
    },
    URGENT: {
        value: 'URGENT',
        label: 'Urgent',
        color: 'error'
    }
}

export const FIELD_ICONS = {
    SSCC: SSCCIcon,
    TYPE: TypeIcon,
    TOUR: TourIcon,
    NOTES: NotesIcon
}
